import { LendingVaultExpanded } from "@bridgesplit/abf-react";
import { LEND_VAULT_DETAIL_SLUG } from "app/constants";

export function getLendingVaultPath(lendVault: LendingVaultExpanded | undefined) {
    if (!lendVault) return "#";
    return `${LEND_VAULT_DETAIL_SLUG}/${lendVault.vault.address}`;
}
